<div class="content">
    <shared-forklift-right-route *ngIf="showDetail" class="route-area" [detail]="detail"
        (refresh)="onRouteRefresh()"></shared-forklift-right-route>
    <shared-forklift-right-actions class="actions-column" [style.flex-basis.px]="actionsWidth"
        [detail]="detail" [accessControlId]="accessControlId"
        (refresh)="onRouteRefresh()" (phaseChanged)="onPhaseChanged($event)"></shared-forklift-right-actions>
</div>
